var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.92682 0C3.55609 0 0 3.55609 0 7.92682C0 12.2978 3.55609 15.8536 7.92682 15.8536C12.2978 15.8536 15.8536 12.2978 15.8536 7.92682C15.8536 3.55609 12.2978 0 7.92682 0ZM7.92682 14.3903C4.36293 14.3903 1.46341 11.4908 1.46341 7.92686C1.46341 4.36296 4.36293 1.46341 7.92682 1.46341C11.4907 1.46341 14.3902 4.36293 14.3902 7.92682C14.3902 11.4907 11.4907 14.3903 7.92682 14.3903Z","fill":"white","key":0}),React.createElement("path",{"d":"M17.786 16.7511L13.5908 12.5559C13.305 12.2701 12.842 12.2701 12.5562 12.5559C12.2703 12.8416 12.2703 13.305 12.5562 13.5906L16.7513 17.7857C16.8942 17.9286 17.0813 18.0001 17.2686 18.0001C17.4557 18.0001 17.643 17.9286 17.786 17.7857C18.0718 17.5001 18.0718 17.0367 17.786 16.7511Z","fill":"white","key":1})]);
}

Search.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Search;

Search.default = Search;
